import { number } from 'prop-types';

import {
  AxisBaseLine,
  VerticalAxis,
  HorizontalAxis,
} from 'components/data-visualization/LineChart/Axes';

/** Create a placeholder SVG based on the LineChart axes */
const LineChartSkeleton = ({ width, height, marginTop }) => {
  return (
    <>
      <HorizontalAxis transform={`translate(0, ${marginTop})`}>
        {[0.1, 0.3, 0.5, 0.7, 0.9].map((offset) => (
          <line
            key={`horizontal-axis-${offset}`}
            className="tick"
            transform={`translate(${width * offset},0)`}
            /** + 6 is the labelOffset set in Axes.js */
            y2={height + 6}
          />
        ))}
      </HorizontalAxis>
      <VerticalAxis transform={`translate(0, ${marginTop})`}>
        {[0, 0.25, 0.5, 0.75].map((offset) => (
          <line
            key={`vertial-axis-${offset}`}
            className="tick"
            transform={`translate(0, ${height * offset})`}
            x2={width}
          />
        ))}
      </VerticalAxis>
      <AxisBaseLine
        x1="0"
        x2={width}
        y1={height + marginTop}
        y2={height + marginTop}
      />
    </>
  );
};

/** @component */
export default LineChartSkeleton;

LineChartSkeleton.propTypes = {
  /** The width of the skeleton */
  width: number,
  /** The height of the skeleton */
  height: number,
  /** The vertical top marginTop for the axis */
  marginTop: number,
};
